<div class="login-container">
    <div class="login" *ngIf="verificationCodeDetails">
        <div class="title">
            <i class="pi pi-user"></i>
            <h2>{{'LOGIN.VERIFICATIN_TITEL' |translate}}</h2>
        </div>
        <div>
            <code-verification [(verificationCode)]="verificationCode" [displaySendAgainByMail]="false"
                (verificationCodeCancel)="onVerificationCodeCancel()" (verificationCodeChange)="verificationOk()"
                (sendAgainVerificationCode)="sendAgainVerificationCode()"
                [verificationCodeDetails]="verificationCodeDetails"
                [(verificationType)]="verificationCodeDetails.verificationType" [lightTitle]="true">
            </code-verification>
        </div>  
    </div>
</div>